import React from 'react'
import defaultAvatar from '../../../assets/images/profile-picture.png'


const RegPlayerAvatar = ({
    imgs = [],
    maxVisible = 4,
    size = 36
}) => {
    const visibleImg = imgs.slice(0, maxVisible);
    const remaining = imgs.length - maxVisible;
    return (
        <div className="sm_event_avatar_group">
            {visibleImg.map((img, index) => (
                <div
                    key={index}
                    className="sm_event_avatar"
                    style={{
                        width: size,
                        height: size,
                        zIndex: maxVisible - index
                    }}
                >
                    <img src={img ? img : defaultAvatar} />
                </div>
            ))}

            {remaining > 0 && (
                <div
                    className="sm_event_avatar more"
                    style={{
                        width: size,
                        height: size
                    }}
                >
                    +{remaining}
                </div>
            )}
        </div>
    )
}

export default RegPlayerAvatar